import type { GetExternalApiTokenResponse } from '@vy/api-definition';
import { GetExternalApiTokenResponseSchema } from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';

export function useGetExternalApiToken(
  options?: UseMutationOptions<GetExternalApiTokenResponse, unknown, void>,
) {
  return useMutation({
    mutationFn: async () => {
      const api = getPrivateApi();

      const getExternalApiTokenResponse = await api.getExternalApiToken();

      return GetExternalApiTokenResponseSchema.parse(getExternalApiTokenResponse);
    },
    ...options,
  });
}
